import React, { FC, ReactElement } from 'react';
import { Anchor, Box, Menu, Nav } from 'grommet';
import { Link } from 'gatsby';
import { menu } from '@/data';
import {
  ThemeModeToggle,
  Menu as MenuIcon,
} from '@pentester.com/grommet-theme';

export const NavMenu: FC = (): ReactElement => (
  <Nav direction="row" align="center">
    {menu.map((item) => (
      <Anchor
        color="text"
        key={item.path}
        as={item.external ? undefined : Link}
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        to={item.path}
        href={item.external ? item.path : undefined}
        label={item.label}
      />
    ))}
    <ThemeModeToggle />
  </Nav>
);

export const MobileNavMenu: FC = (): ReactElement => (
  <Box direction="row" gap="xsmall" align="center">
    <ThemeModeToggle />
    <Menu
      margin={{ top: `xsmall` }}
      icon={false}
      label={<MenuIcon alignSelf="center" />}
      dropProps={{
        a11yTitle: `Menu`,
        align: { top: `bottom`, left: `left` },
      }}
      items={menu.map((item) => ({
        label: item.label,
        as: item.external ? undefined : Link,
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        to: item.path,
        href: item.external ? item.path : undefined,
      }))}
    />
  </Box>
);
